import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function RiskRadar({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="risk"
      eyebrow="Predictive intelligence"
      title="Risk Radar"
      description="Ranked operational risk, contributors and recommended intervention."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
